import React from "react";
import Billing from "../../Billing/Billing";
import OrthoptistOptions from "./OrthoptistOptions";
import UserOptions from "./UserOptions";
import SubscriptionSettings from "./SubscriptionSettings";


function OrthoptistSettings({orthoptist_id}) {
        return (
            <div>
                <div className="row" style={{gap: 20}}>
                    <div className="col xl7 m12">
                        <Billing orthoptist_id={orthoptist_id}/>
                    </div>
                    <div className="col xl5 m12" style={{display: "flex", flexDirection: "column", gap: 20}}>
                        <OrthoptistOptions orthoptist_id={orthoptist_id}/>
                        <UserOptions orthoptist_id={orthoptist_id}/>
                        <SubscriptionSettings orthoptist_id={orthoptist_id}/>
                    </div>
                </div>
            </div>
        )
}

export default OrthoptistSettings;
